module.exports = __webpack_public_path__ + "media/images/lb/822-558da378320e36d873d1ce7730cd7804.svg";